import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.5 12c0 5.799-4.701 10.5-10.5 10.5a10.466 10.466 0 0 1-7.348-3M22.5 12c0-3.345-1.564-6.324-4-8.247m4 8.247h-2L19 10.5l-3 .5-2-2.5-1.5-.5.5-1.5 1.5-1L17 5l1.5-1.247m0 0A10.455 10.455 0 0 0 12 1.5a10.49 10.49 0 0 0-8.757 4.704M4.652 19.5v-3.13L6 14.5l-2-1-2.26.738M4.651 19.5a10.483 10.483 0 0 1-2.913-5.262m0 0a10.54 10.54 0 0 1-.16-3.534m0 0L5 8.5v-1L3.243 6.204m-1.664 4.5c.203-1.649.788-3.18 1.664-4.5M10 13v2l2.5 1v4.5l3-2 1-4-2-2H11l-1 .5Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }